import React from 'react'

const SonyBVW60 = () => {
  return (
    <div>SonyBVW60</div>
  )
}

export default SonyBVW60